import React, { useEffect, useState, useRef } from "react";
import SimpleReactValidator from "simple-react-validator";
import QRCode from 'qrcode.react';
import { Controller, useForm } from "react-hook-form";
import { Hidden } from "react-awesome-styled-grid";
import AsYouType, { getCountryCallingCode } from "libphonenumber-js";
import SmallScreenView from "../../components/smallscreen";
import { COUNTRY_PHONE_CODE, INDIAN_STATES, EMAIL, TABLET_SCREEN_WIDTH, TabNames } from "../../appconstants";
import {
  addUpiPaymentsChargeById,
  payInvoiceById,
  getServerEncription,
  generateClientKeyPair,
  encryptData,
} from "../../api";
import {
  CancelButton,
  FlexContainer,
  H1Text,
  Hr,
  Input,
  InputWrapper,
  LabelText, SpanText,
  SubmitButton,
  PH3Text,
  UpiPanel,
  UpiPanel1,
  Text,
  Img,
  RoundButton,
} from "../../design";
import {
  SpError,
} from '../../widgetDesign';
import PaymentError from "../paymenterror";
import { ErrorMessage } from "@hookform/error-message";
import Select from "react-select";
import NumberFormat from "react-number-format";
import QRIcon from "../../assets/imgs/qr-img.svg";
import Arrow from "../../assets/imgs/qr-arrow.svg";
import Bhim from "../../assets/imgs/bhim.svg";
import Gpay from "../../assets/imgs/gpay.svg";
import Paytm from "../../assets/imgs/paytm.svg";
import PhonePay from "../../assets/imgs/phonepay.svg";
import User from "../../assets/imgs/paytm-user.svg";
import { isValidPhoneNumber } from 'libphonenumber-js';
import ReCAPTCHA from 'react-google-recaptcha';
import { AmountDivideByHundred } from "../../helper";
import { format } from "../../utils/timer";
import { Button, Col, Row, Modal } from "antd";
import useDetectWebPageVisibility from "../../hooks/useDetectWebPageVisibility";
import { useDispatch, useSelector } from "react-redux";
import { setIsWaitingForUpiApp, setUserReturnedFromUpiApp } from "../../redux/appConfigInfo";
import UpiAccordion from "./Component/UpiAccordion";

type Props = {
  errorMsg: string,
  errorHeader: string,
  customerReadOnly: boolean,
  submit: Function,
  preFillCustomer: {
    name: string,
    email: string,
    phoneNumber: string,
  },
  customerFields: {
    name: string,
    contactUsEmail: string,
    contactUsPhone: string,
  },
  headerText: string,
  buttonText: string,
  customerValidation: boolean,
  alpha2: string,
  cancel: Function,
  getPaymentById: Function,
  showCancelBtn: boolean,
  cancelButtonText: string,
  paymentWidget: boolean,
  upiUrl: String,
  paymentMethodDetails: boolean,
  paymentPageDetails: boolean,
  showMobileViewUpi: boolean,
  paymentPagePay: boolean,
  invoicePay: boolean,
  hideQr: boolean,
  paymentPageMeta: string,
  currentCustomerGid: string,
  supportPhoneNumber: string,
  showWhatsAppNotify: Boolean,
  isCaptchaEnabled: Boolean,
  sitekey: String,
  paymentPageEntries: Array,
  account: Object,
  supportedPaymentTypes: Array,
  netAmount: Number,
  serviceFeeAmount: Number,
  totalPayableAmount: Number,
  serviceFeeEnabled: Boolean,
  prefix: string,
  setRecaptchaModalVisible: Function,
  setSavedPaymentDetails: Function,
  savedPaymentDetails: Object,
  globalRecaptchaToken: String,
  setGlobalRecaptchaToken: Function,
  setRecaptchaPaymentType: Function,
  phoneInputReadOnly: Boolean,
  onReturnFromUpiApp: Function,
  onChargeByUpiIndent: Function,
  showIndentCustomer: Boolean,
}

const UpiPayment = (props: Props) => {
  const { submit, preFillCustomer, paymentWidget, account, paymentPagePay, sitekey, isCaptchaEnabled, customerFields,
    headerText, buttonText, errorHeader, errorMsg, supportPhoneNumber, hideQr, showWhatsAppNotify, paymentPageEntries,
    customerReadOnly, customerValidation, supportedPaymentTypes, alpha2, showCancelBtn, cancel, cancelButtonText, upiUrl, getPaymentById, paymentMethodDetails, paymentPageDetails, paymentPageMeta, showMobileViewUpi, currentCustomerGid, invoicePay,
    netAmount, serviceFeeAmount, totalPayableAmount, serviceFeeEnabled, prefix, expireyText, count,  setRecaptchaModalVisible,
    setSavedPaymentDetails, savedPaymentDetails, globalRecaptchaToken, setGlobalRecaptchaToken, setRecaptchaPaymentType, phoneInputReadOnly,
    onReturnFromUpiApp, onChargeByUpiIndent, showIndentCustomer
   } = props;

  const [isShowErrorMessage, setShowErrorMessage] = useState(false);
  const [showCancelButton, setShowCancelButton] = useState(showCancelBtn);
  const [customerReadOnlyList, setCustomerReadOnlyList] = useState([]);
  const [showQrCode, setShowQrCode] = useState(false);
  const [address, setAddress] = useState(null);
  const [loading, setLoading] = useState(false);
  const [hideUpiId, setHideUpiId] = useState(true);
  const [qrCodeText, setQRCodeText] = useState('');
  const [invalidQR, setInvalidQR] = useState(null);
  const [phoneNumber, setPhoneNumber] = useState(null);
  const [supportNumber, setSupportNumber] = useState(null);
  const [upiPayload, setUpiPayload] = useState('');
  const [upiId, setUpiId] = useState('');
  const [styleClass, setStyleClass] = useState('col-sm-6 pl-0');
  const [paymentSession, setPaymentSession] = useState('');
  const [psClientSecret, setPsClientSecret] = useState('');
  const [redirectionUri, setRedirectionUri] = useState('');
  const [recaptchaToken, setRecaptchToken] = useState(null);
  const [showCaptchError, setShowCaptchError] = useState(null);
  const [upiModalVisible, setUpiModalVisible] = useState(false);
  const [customerDetailsIndent, setCustomerDetailsIndent] = useState(null);
  const { isWaitingForUpiApp, userReturnedFromUpiApp } = useSelector((state) => state.appConfigInfo);

  const [, forceUpdate] = useState();
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const dispatch = useDispatch();
  useDetectWebPageVisibility();

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (globalRecaptchaToken
      && savedPaymentDetails
    ) {
      onClickQrCode(savedPaymentDetails, globalRecaptchaToken);
      setGlobalRecaptchaToken(null);
    }
  }, [globalRecaptchaToken]);

  useEffect(() => {
    if (isWaitingForUpiApp && userReturnedFromUpiApp) {
      onReturnFromUpiApp();
      dispatch(setUserReturnedFromUpiApp(false));
      dispatch(setIsWaitingForUpiApp(false));
    }
  }, [isWaitingForUpiApp, dispatch, userReturnedFromUpiApp, onReturnFromUpiApp]);
  
  const simpleValidator = useRef(new SimpleReactValidator({
    validators: {
      validUpi: {
        message: 'The upi id is invalid',
        rule: val => (new RegExp(/^\w.+@\w+$/).exec(val) !== null),
      },
    },
  }));
  let apiInterval;
  const BACKGROUND_COLOR = '#E8ECED';
  const COLOR = '#6A6A6A';

  useEffect(() => {
    setShowCancelButton(showCancelBtn);
  }, [showCancelBtn]);

  useEffect(() => {
    if (paymentWidget) {
      setStyleClass('col-sm-12 pl-0');
    }
  }, [paymentWidget]);

  const {
    control,
    handleSubmit,
    errors,
    reset,
    setValue,
  } = useForm();

  const [checked, setChecked] = useState(false);

  useEffect(() => {
    setValue('notify', checked);
  }, [checked]);

  useEffect(() => {
    if (preFillCustomer) {
      const phone = preFillCustomer && preFillCustomer.phoneNumber && AsYouType(preFillCustomer.phoneNumber);
      setPhoneNumber(phone && phone.nationalNumber);
      const upiSupportPhone = supportPhoneNumber && AsYouType(supportPhoneNumber);
      setSupportNumber(upiSupportPhone && upiSupportPhone.nationalNumber);
      const countryCallingCode = phone && `+${phone.countryCallingCode}` || alpha2 && `+${getCountryCallingCode(alpha2)}`;
      const address = preFillCustomer && preFillCustomer.billingAddress;
      setAddress(address);
      setUpiPayload({
        name: preFillCustomer && preFillCustomer.name || "",
        email: preFillCustomer && preFillCustomer.email || "",
        phone: phone && phone.nationalNumber || "",
        countryCallingCode: countryCallingCode && findCountryCallingCode(countryCallingCode) || "",
        address: address && address.street,
        city: address && address.city,
        postalCode: address && address.postalCode,
        state: address && findStateByCode(address.state),
      });
      reset({
        name: preFillCustomer && preFillCustomer.name || "",
        email: preFillCustomer && preFillCustomer.email || "",
        phone: phone && phone.nationalNumber || "",
        countryCallingCode: countryCallingCode && findCountryCallingCode(countryCallingCode) || "",
        address: address && address.street,
        city: address && address.city,
        postalCode: address && address.postalCode,
        state: address && findStateByCode(address.state),
      })
    }
  }, [reset, preFillCustomer]);

  useEffect(() => {
    if (paymentPagePay) {
      const phone = customerFields && customerFields.contactUsPhone && AsYouType(customerFields.contactUsPhone);
      const countryCallingCode = phone && `+${phone.countryCallingCode}` || alpha2 && `+${getCountryCallingCode(alpha2)}`;
      reset({
        cname: customerFields && customerFields.name || "",
        email: customerFields && customerFields.contactUsEmail || "",
        phone: phone && phone.nationalNumber || "",
        countryCallingCode: countryCallingCode && findCountryCallingCode(countryCallingCode) || "",
      })
    }
  }, [reset, customerFields])

  // useEffect(() => {
  //   if (errorMsg) {
  //     setShowErrorMessage(true);
  //   } else setShowErrorMessage(false);
  // }, [errorMsg]);

  const findCountryCallingCode = (value) => (
    value && COUNTRY_PHONE_CODE.includes(value) && { value }
  );

  const findStateByCode = (code) => (
    INDIAN_STATES.find(value => value.code === code)
  );

  useEffect(() => {
    setCustomerReadOnlyList([]);
    const localCustomerReadOnlyList = new Set();
    if (phoneInputReadOnly) {
      localCustomerReadOnlyList.add('phone');
    }
    if (customerReadOnly) {
      localCustomerReadOnlyList.add('name');
      localCustomerReadOnlyList.add('email');
      localCustomerReadOnlyList.add('phone');
    }
    setCustomerReadOnlyList([...localCustomerReadOnlyList]);
  }, [props.customerReadOnly, phoneInputReadOnly, preFillCustomer]);

  const customStyles = {
    container: base => ({
      ...base,
      width: '100%',
      height: '41px',
      // marginTop: '8px',
      marginBottom: '8px',
      borderRadius: '10px',
    }),
    control: base => ({
      ...base,
      height: '41px',
      minHeight: '41px',
      border: '1px solid #CCCCCC',
      boxShadow: 'none',
      borderColor: '#CCCCCC !important',
      marginTop: '8px',
      width: '100%'
    }),
    dropdownIndicator: base => ({
      ...base,
      height: 33,
      minHeight: 33,
    })
  };

  const phoneCustomStyles = {
    container: base => ({
      height: '41px',
      maxWidth: '100px !important',
    }),
    control: base => ({
      ...base,
      height: '35px',
      minHeight: '35px',
      width: '100px',
      border: 'none',
      borderRight: '1px solid #CCCCCC',
      boxShadow: 'none',
      borderColor: '#CCCCCC !important'
    }),
  };

  const disableStyles = {
    container: base => ({
      height: '41px',
      // maxWidth: "100px !important",
    }),
    control: base => ({
      ...base,
      height: '41px',
      minHeight: '41px',
      border: 'none',
      borderRight: '1px solid #CCCCCC',
      boxShadow: 'none',
      borderColor: '#CCCCCC !important',
      background: '#E8ECED',
      color: '#6A6A6A'
    }),
  };

  const customUpiSubmitButtonStyle = {
    width: '100%',
    backgroundColor: '#0b64bc',
    fontSize: '15px',
    fontWeight: '600',
  };

  const onSubmit = data => {
    if (recaptchaToken) {
      setShowCaptchError(null);
    } else {
      setShowCaptchError('Captcha is required');
    }
    const { name, email, vpa, phone, countryCallingCode, notify, } = data;
    const phoneNumber = countryCallingCode && countryCallingCode.value && `${countryCallingCode.value}${phone}`;
    const customer = { name, email, phoneNumber };
    const paymentMethod = { type: "UPI", upi: { vpa } };
    const finalData = { ...data, phoneNumber, notify, customer, paymentMethod, recaptchaToken };
    if (isCaptchaEnabled) {
      if (recaptchaToken) {
        if (submit) { submit(finalData); }
      }
    } else {
      if (submit) { submit(finalData); }
    }
  };

  useEffect(() => {
    if (!hideUpiId) {
      const interval = setInterval(() => {
        getPaymentById(paymentSession, psClientSecret, redirectionUri);
      }, 10000);
      return () => clearInterval(interval);
    }
  }, [hideUpiId]);

  const isPhoneNumberValidate = (data: string) => {
    const cuntryCode = control.getValues().countryCallingCode.value;
    const phoneNum = control.getValues().phone;
    if (!isValidPhoneNumber(`${cuntryCode}${phoneNum}`)) {
      return 'The phone number is invalid';
    }
  };


  const onUpiSubmit = (data, event) => {
    event.preventDefault();
    const formValid = simpleValidator.current.allValid();
    setShowErrorMessage(false);
    if (!formValid) {
      simpleValidator.current.showMessages();
      forceUpdate(1);
      return;
    }
    const { name, email, phone, countryCallingCode, notify } = upiPayload;
    const phoneNumber = phone ? countryCallingCode && countryCallingCode.value && `${countryCallingCode.value}${phone}` : supportPhoneNumber;
    const customer = { name, email, phoneNumber };
    const paymentMethod = { type: "UPI", upi: { vpa: upiId } };
    const finalData = { ...upiPayload, phoneNumber, customer, notify, paymentMethod };
    if (showIndentCustomer) {
      finalData.mobileViewCustomerDetails = data;
    }
    submit(finalData);
  };

  const onClickQrCode = async (data, recaptchaToken = null) => {
    const originalData = data;
    if (data === 'prev') {
      clearInterval(apiInterval);
      setHideUpiId(true);
    } else {
      setLoading(true);
      let data;
      if (paymentMethodDetails === true) {
        data = {
          "paymentMethodDetails": {
            "subType": "QR",
            "type": "UPI"
          },
        }
      } else if (invoicePay === true) {
        data = {
          "paymentMethod": {
            "subType": "QR",
            "type": "UPI",
            "customerGid": currentCustomerGid,
          },
        }
      } else if (paymentPagePay === true) {
        const coustomer = {
          name: account && account.name,
          email: customerFields.contactUsEmail,
          phoneNumber: customerFields.contactUsPhone,
        };
        data = {
          "paymentMethodType": [
            "UPI"
          ],
          "paymentMethodDetails": {
            "type": "UPI",
            "subType": "QR"
          },
          paymentPageEntries,
          customerDetails: coustomer,
          "paymentPageMetaGid": paymentPageMeta.gid,
          "shouldWhatsAppNotify": false,
        }
      } else {
        data = {
          "paymentMethod": {
            "subType": "QR",
            "type": "UPI"
          },
        }
      }
      try {
        let value;
        const serverSideEncryptionValue = await getServerEncription(recaptchaToken);
        if (serverSideEncryptionValue?.public_key) {
          const keys = generateClientKeyPair();
          if (keys?.privateKey) {
            const encriptedData = encryptData(
              JSON.stringify(data),
              serverSideEncryptionValue.public_key,
              keys.privateKey,
              serverSideEncryptionValue.key_id
            );
            const payload = {
              publicKey: keys?.publicKey,
              keyId: encriptedData?.keyId,
              iv: encriptedData?.iv,
              data: encriptedData?.encryptedData,
            };
            if (encriptedData?.keyId) {
              if (invoicePay === true) {
                value = await payInvoiceById(upiUrl, payload);
                if (value && value.nextActionUrl) {
                  const { nextActionUrl } = value;
                  if (nextActionUrl) {
                    window.location = nextActionUrl;
                    return;
                  }
                }
                if (value && value.paymentSession) {
                  setPaymentSession(value.paymentSession.gid || null);
                  setPsClientSecret(value.paymentSession.psClientSecret || null);
                  setRedirectionUri(value.redirectUri || null);
                  setQRCodeText(value.paymentSession.qrUrl);
                  setLoading(false);
                  setHideUpiId(false);
                }
              } else {
                value = await addUpiPaymentsChargeById(upiUrl, payload);
                if (value && value.nextActionUrl) {
                  const { nextActionUrl } = value;
                  if (nextActionUrl) {
                    window.location = nextActionUrl;
                    return;
                  }
                }
                if (value && value.qrUrl) {
                  setPaymentSession(value.paymentSessionGid || null);
                  setPsClientSecret(value.psClientSecret || null);
                  setRedirectionUri(value.redirectUri || null);
                  setQRCodeText(value.qrUrl);
                  setLoading(false);
                  setHideUpiId(false);
                }
              }
            }
          }  
        }
      } catch (err) {
        setLoading(false);
        setHideUpiId(true);
        if (err?.status === 429){
          setSavedPaymentDetails(originalData);
          setRecaptchaModalVisible(true);
          setRecaptchaPaymentType(TabNames.UPI);
          return;
        }
        setInvalidQR('QR is not supported for this payment')
        setShowErrorMessage(true);
      }
    }
  };

  const onCancel = () => { showCancelButton && cancel && cancel(); };

  const customInputStyle = {
    background: 'white',
    // color: 'black',
    borderColor: '#CCCCCC',
    width: '100%',
    height: '41px',
    paddingLeft: '15px',
  };

  const customLabelStyle = {
    color: 'black'
  };

  const customRowFlexContainerProps = {
    xs: '100%',
    md: '100%',
    gap: '5%',
  };

  const customColFlexContainerProps = {
    xs: '100%',
    md: '47.5%',
    flexDirection: 'col',
  };

  const customSubmitButtonStyle = {
    borderRadius: '10px',
    width: (screenWidth < TABLET_SCREEN_WIDTH ? '100%' : '30%'),
    backgroundColor: '#0b64bc',
    height: 'auto',
    margin: '0px',
    padding: '5px 0',
  };

  const customCancelButtonStyle = {
    borderRadius: '10px',
    width: (screenWidth < TABLET_SCREEN_WIDTH ? '100%' :  '30%'),
    background: '#e53935',
    height: '43px',
    color: 'white',
    display: 'flex',
    alignContent: 'center',
    justifyContent: 'center',
    alignItems: 'center',
    paddingLeft: '50px',
    paddingRight: '50px',
    paddingTop: '0px',
    // paddingBottom: '15px',
    fontSize: '20px',
  }

  const onUpiIndentCustomerSubmit = (data) => {
    const { name, email, phone, countryCallingCode } = data;
    const phoneNumber = phone ? countryCallingCode && countryCallingCode.value && `${countryCallingCode.value}${phone}` : null;
    const customer = { name, email, phoneNumber };
    setUpiModalVisible(true);
    setCustomerDetailsIndent(customer);
  };

  return (
    <>
      {/* <H1Text
        className="px-1 px-md-4 mb-0"
      >
        <SmallScreenView>
          {"Pay With UPI ID"}
        </SmallScreenView>
        <Hidden sm xs>
          {headerText || "Pay With UPI"}
        </Hidden>
      </H1Text> */}
      {
        expireyText && (
          <p 
            // className="px-4 px-md-4 mb-4"
            style={{
              width: '100%',
              display: 'flex'
            }}
            className="px-4 pb-2 px-md-4"
          >
            <section>
              {expireyText} 
              <span style={{ 
                  fontWeight: "600",
                  marginLeft: "3px",
                }}
              >
                {format(count)}
              </span>
            </section>
          </p>
        )
      }
      <div className="px-4 pb-4 px-md-4 mt-2">
        {
          showMobileViewUpi && (
            <>
              <SmallScreenView>
                {showIndentCustomer && (
                  <form onChange={() => setShowErrorMessage(false)} style={{ width: '100%' }}>
                    <FlexContainer {...customRowFlexContainerProps}>
                      <PH3Text className="mb-3 mt-5 mx-0 p-0" fontWeight="bold">CUSTOMER DETAILS</PH3Text>
                    </FlexContainer>
                    <FlexContainer {...customRowFlexContainerProps}>
                      <FlexContainer {...customColFlexContainerProps}>
                        <LabelText style={customLabelStyle}>Name</LabelText>
                        <Controller
                          defaultValue={""}
                          color={errors.name ? "red" : "inherit"}
                          marginBottom="0px"
                          control={control}
                          name="name"
                          placeholder="Enter your name"
                          rules={customerValidation && {
                            required: 'This field is required'
                          }}
                          as={
                            <Input
                              readOnly={customerReadOnlyList && customerReadOnlyList.includes("name")}
                              style={{
                                ...customInputStyle,
                                background: (customerReadOnlyList && customerReadOnlyList.includes("name")) ? BACKGROUND_COLOR : customInputStyle.background,
                                color: (customerReadOnlyList && customerReadOnlyList.includes("name")) ? COLOR : customInputStyle.color,
                              }}
                            />
                          }
                        />
                        <ErrorMessage
                          errors={errors}
                          name="name"
                          render={({ message }) => (
                            <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                          )}
                        />
                      </FlexContainer>
                      <FlexContainer {...customColFlexContainerProps}>
                        <LabelText style={customLabelStyle}>E-mail</LabelText>
                        <Controller
                          marginBottom="0px"
                          defaultValue={""}
                          color={errors.email ? "red" : "inherit"}
                          control={control}
                          name="email"
                          placeholder="Enter your email address"
                          rules={customerValidation && {
                            required: 'This filed is required',
                            pattern: {
                              value: EMAIL.DEFAULT_REGEX,
                              message: 'The email is invalid',
                            },
                          }}
                          as={
                            <Input
                              readOnly={customerReadOnlyList && customerReadOnlyList.includes("email")}
                              style={{
                                ...customInputStyle,
                                background: (customerReadOnlyList && customerReadOnlyList.includes("email")) ? BACKGROUND_COLOR : customInputStyle.background,
                                color: (customerReadOnlyList && customerReadOnlyList.includes("email")) ? COLOR : customInputStyle.color,
                              }}
                              />
                            }
                        />
                        <ErrorMessage
                          errors={errors}
                          name="email"
                          render={({ message }) => (
                            <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                          )}
                        />
                      </FlexContainer>
                    </FlexContainer>
                    <FlexContainer {...customRowFlexContainerProps}>
                      <FlexContainer {...customColFlexContainerProps}>
                        <LabelText style={customLabelStyle}>Phone</LabelText>
                        <InputWrapper 
                          className="row" 
                          display="flex" 
                          // marginTop="8px" 
                          // borderRadius="4px" 
                          // width='100%'
                          style={{
                            ...customInputStyle,
                            marginTop: '8px',
                            background: customerReadOnlyList && customerReadOnlyList.includes("phone") ? BACKGROUND_COLOR : customInputStyle.background,
                            color: customerReadOnlyList && customerReadOnlyList.includes("phone") ? COLOR : customInputStyle.color,
                          }}
                        >
                          <Controller
                            defaultValue={""}
                            color={errors.countryCallingCode ? "red" : "inherit"}
                            marginBottom="0px"
                            control={control}
                            name="countryCallingCode"
                            placeholder="select"
                            rules={customerValidation && {
                              required: 'Calling Code is required'
                            }}
                            as={<Select
                              className="col-4 px-0 border-0"
                              menuPlacement="auto"
                              isSearchable={!customerReadOnlyList && customerReadOnlyList.includes("phone")}
                              menuIsOpen={customerReadOnlyList && customerReadOnlyList.includes("phone") ? false : undefined}
                              getOptionLabel={(option) => option.value}
                              styles={customerReadOnlyList && customerReadOnlyList.includes("phone") ? disableStyles : phoneCustomStyles}
                              options={COUNTRY_PHONE_CODE.map(value => { return { value } })} />}
                          />
                          <Controller
                            className="col"
                            defaultValue={""}
                            color={errors.phone ? "red" : "inherit"}
                            border="0px !important"
                            marginBottom="0px"
                            marginTop="0px"
                            marginLeft="0px"
                            paddingRight="0"
                            control={control}
                            name="phone"
                            rules={customerValidation && {
                              required: 'This filed is required',
                              validate: isPhoneNumberValidate
                            }}
                            as={
                              <Input
                                type='tel'
                                minLength={6}
                                maxLength={10}
                                readOnly={customerReadOnlyList && customerReadOnlyList.includes("phone")}
                                style={{
                                  ...customInputStyle,
                                  height: '35px',
                                  background: (customerReadOnlyList && customerReadOnlyList.includes("phone")) ? BACKGROUND_COLOR : customInputStyle.background,
                                  color: (customerReadOnlyList && customerReadOnlyList.includes("phone")) ? COLOR : customInputStyle.color,
                                }}
                              />
                            }
                            placeholder="Enter your phone number"
                            customInput={Input}
                          />
                        </InputWrapper>
                        <ErrorMessage
                          errors={errors}
                          name="phone"
                          render={({ message }) => (
                            <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                          )}
                        />
                      </FlexContainer>
                    </FlexContainer>
                  </form>
                )}
                {navigator.userAgent.match(/iPhone|iPad|iPod/i) && (
                  <>
                    <div className="mt-2 ml-1 w-50">
                      <Input
                        placeholder="Enter your Upi ID"
                        style={{ border: '1px solid #9A9A9A' }}
                        value={upiId}
                        onChange={(e) => setUpiId(e.currentTarget.value)}
                      />
                    </div>
                    <div className="ml-1 mt-1">
                      <SpError>
                        {simpleValidator.current.message('upiId', upiId, 'required|validUpi')}
                      </SpError>
                    </div>
                    <Hr />
                    <div className="px-1 px-md-4">
                      <FlexContainer
                        width="100%"
                        justifyContent="space-between"
                      >
                        <SubmitButton
                          type="submit"
                          onClick={(e) => {
                            if(showIndentCustomer) {
                              handleSubmit(onUpiSubmit)(e);
                            } else {
                              onUpiSubmit(null, e);
                            }
                          }}
                          className="ml-5"
                        >{buttonText || "PAY"}</SubmitButton>
                      </FlexContainer>
                      <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#484848">
                        *No fees applicable for UPI/QR payments
                      </Text>
                      {/* {isShowErrorMessage && <PaymentError header={invalidQR || errorHeader} message={errorMsg} />} */}
                      {isShowErrorMessage && invalidQR && <PaymentError header={invalidQR || errorHeader} message={errorMsg} />}
                    </div>
                  </>
                )}
                {navigator.userAgent.match(/Android/i) && supportedPaymentTypes.includes('UPI_INDENT') && (
                  <>
                    <Row className='mt-3 justify-content-center align-items-center' gutter={[16, 16]}>
                      <Col xs={24} sm={24} md={12} lg={8}>
                        <Button style={customUpiSubmitButtonStyle} type="primary" onClick={() => {
                          if(showIndentCustomer) {
                            handleSubmit(onUpiIndentCustomerSubmit)();
                          } else {
                            setUpiModalVisible(true);
                          }
                        }}>
                          Pay with UPI App
                        </Button>
                      </Col>
                    </Row>
                    <Modal title="Select App" open={upiModalVisible} footer={null} closable={false}>
                      <UpiAccordion customerDetails={customerDetailsIndent} fetchUpiUrl={onChargeByUpiIndent} />
                    </Modal>
                  </>
                )}  
              </SmallScreenView>
            </>
          )
        }
        <Hidden sm  xs>
          <form
            hidden={showQrCode}
            onSubmit={(e) => {
              e.preventDefault();
              handleSubmit(onSubmit)(e);
            }}
            onChange={() => setShowErrorMessage(false)}
            style={{
              width: '100%',
            }}
          >
            {

              loading ? (
                <>
                  <div style={{ marginLeft: '150px' }} className="spinner-border text-muted mr-4"> </div>
                </>
              ) : (
                <FlexContainer
                  flexDirection="column"
                  width="100%"
                >
                  {
                    hideUpiId ? (
                      <>
                        <FlexContainer {...customRowFlexContainerProps}>
                          {
                            sitekey && (isCaptchaEnabled === true) && 
                            (
                              <div className="mt-3">
                                <ReCAPTCHA
                                  sitekey={sitekey}
                                  value={recaptchaToken}
                                  onChange={(value) => {
                                    setRecaptchToken(value);
                                    setShowCaptchError(null);
                                  }}
                                />
                                {
                                  (Object.keys(errors).length > 0) && (!recaptchaToken) ? (
                                    <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">Captcha is required</Text>
                                  ) : showCaptchError ? (
                                    <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{showCaptchError}</Text>
                                  ) : ''
                                }
                              </div>
                            )
                          }
                        </FlexContainer>
                        {
                          !hideQr && (
                            <>
                              {
                                supportedPaymentTypes && supportedPaymentTypes.includes('QR') && !(navigator.userAgent.match(/Android/i)) ? (
                                  <>
                                    {/* <Hr /> */}
                                    <FlexContainer {...customRowFlexContainerProps}>
                                      <div
                                        onClick={() => onClickQrCode('next')}
                                        className={styleClass}
                                      >
                                        <UpiPanel>
                                          <Img
                                            style={{
                                              marginTop: '19px',
                                              marginLeft: '16px',
                                            }}
                                            src={QRIcon}
                                          />
                                          <PH3Text>Show QR</PH3Text>
                                          <PH3Text
                                            marginTop='5px'
                                            fontSize='11px'
                                            color='#848484'
                                          >
                                            Scan the QR code using your UPI app
                                          </PH3Text>
                                          <p
                                            style={{
                                              marginLeft: '90%',
                                              marginTop: '-19px',
                                            }}
                                          >
                                            <Img
                                              src={Arrow}
                                            />
                                          </p>
                                        </UpiPanel>
                                      </div>
                                    </FlexContainer>
                                    {/* <Hr /> */}
                                  </>
                                ) : null
                              }
                            </>
                          )
                        }
                        <FlexContainer {...customRowFlexContainerProps}>
                          {
                            (serviceFeeEnabled === true) && (
                              <div 
                                // className="px-1 px-md-4"
                              >
                                <div class="mt-4">
                                  <table class="table table-bordered mt-4">
                                    <tbody>
                                      <tr style={{ borderBottom: 'hidden' }}>
                                        <th scope="row">Amount:</th>
                                        <td>{prefix} {AmountDivideByHundred(netAmount)}</td>
                                      </tr>
                                      <tr style={{ borderBottom: 'hidden' }}>
                                        <th scope="row">Service Fee:</th>
                                        <td>{prefix} {AmountDivideByHundred(serviceFeeAmount)}</td>
                                      </tr>
                                      <tr style={{ background: '#F7F7F7' }}>
                                        <th scope="row">Total Payable:</th>
                                        <td class="font-weight-bold">{prefix} {AmountDivideByHundred(totalPayableAmount)}</td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            )
                          }
                        </FlexContainer>
                        {/* <FlexContainer {...customRowFlexContainerProps}>
                          <FlexContainer
                            width="100%"
                            alignItems="center"
                            justifyContent="space-evenly"
                          >
                            {
                              (showCancelButton && cancel) &&
                              <SpanText
                                onClick={onCancel}
                                cursor="pointer"
                                color="#40A9FF"
                                className="cursor-pointer"
                                style={{
                                  ...customCancelButtonStyle,
                                  padding: '5%',
                                  width: 'auto',
                                  marginTop: '10%',
                                }}
                              >
                                {cancelButtonText || "Cancel"}
                              </SpanText>
                            }
                            <SubmitButton
                              type="submit"
                              // className="ml-5"
                              style={{
                                ...customSubmitButtonStyle,
                                marginTop: '10%',
                              }}
                            >
                              {buttonText || "PAY"}
                            </SubmitButton>
                          </FlexContainer> */}
                          {/* {isShowErrorMessage && <PaymentError header={errorHeader} message={invalidQR || errorMsg} />} */}
                          {/* {isShowErrorMessage && <PaymentError header={errorHeader} message={invalidQR} />} */}
                        {/* </FlexContainer> */}
                      </>
                    ) : (
                      <FlexContainer {...customRowFlexContainerProps}>
                        <FlexContainer {...customColFlexContainerProps}>
                          <div
                            onClick={() => onClickQrCode('prev')}
                            className={styleClass}
                          >
                            <UpiPanel>
                              <Img
                                style={{
                                  marginTop: '19px',
                                  marginLeft: '16px',
                                }}
                                src={User}
                              />
                              <PH3Text>UPI ID</PH3Text>
                              <PH3Text
                                marginTop='5px'
                                fontSize='11px'
                                color='#848484'
                              >
                                Use your UPI Id
                              </PH3Text>
                              <p
                                style={{
                                  marginLeft: '90%',
                                  marginTop: '-19px',
                                }}
                              >
                                <Img
                                  src={Arrow}
                                />
                              </p>
                            </UpiPanel>
                          </div>
                        </FlexContainer>
                        <Hr />
                        <FlexContainer
                          {...customColFlexContainerProps} 
                          md="100%"
                          justifyContent="center"
                          alignItems="center"
                          alignContent="center"
                        >
                          <div 
                            className={styleClass}
                            style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    alignContent: 'center',
                                    alignItems: 'center',
                                  }}
                          >
                            <H1Text className="mt-4">
                              PAY USING QR CODE
                            </H1Text>
                            <UpiPanel1>
                              <PH3Text
                                marginTop='40px'
                                marginLeft='35px'
                                fontSize='11px'
                                color='#848484'
                              >
                                Scan the QR using any UPI app on your phone
                              </PH3Text>
                              <PH3Text
                                marginTop='5px'
                                marginLeft='40px'
                                fontSize='11px'
                                color='#848484'
                              >
                                like BHIM, PhonePe, Google Pay etc.
                              </PH3Text>
                              <div
                                style={{
                                  marginTop: '15px',
                                  marginLeft: '55px',
                                }}
                              >
                                <Img
                                  src={Bhim}
                                  marginRight='15px'
                                />
                                <Img
                                  src={PhonePay}
                                  marginRight='15px'
                                />
                                <Img
                                  src={Gpay}
                                  marginRight='15px'
                                />
                                <Img
                                  src={Paytm}
                                  marginRight='15px'
                                />
                              </div>
                              <div
                                style={{
                                  marginTop: '40px',
                                  marginLeft: '20%',
                                }}
                              >
                                <QRCode
                                  id="qrCodeEl"
                                  size={160}
                                  value={qrCodeText}
                                />
                              </div>
                            </UpiPanel1>
                          </div>
                        </FlexContainer>
                      </FlexContainer>
                    )
                  }
                </FlexContainer>
              )
            }
          </form>
        </Hidden>
      </div>
    </>
  )
};

export default UpiPayment;
